import React, {ReactNode} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingCarouselWorkflowTemplateId} from './onboardingCarouselResourceTemplates';

export enum OnboardingWorkflowsOutcomesV2 {
  NO_CUSTOMER_WAITING = 'no_customer_waiting',
  HANDLED = 'handled',
  CATEGORIZED = 'categorized',
}

interface OnboardingWorkflowsOutcomesData {
  label: ReactNode;
  templates: ReadonlyArray<OnboardingCarouselWorkflowTemplateId>;
}

export const onboardingWorkflowsOutcomesConstantsV2: Record<
  OnboardingWorkflowsOutcomesV2,
  OnboardingWorkflowsOutcomesData
> = {
  [OnboardingWorkflowsOutcomesV2.NO_CUSTOMER_WAITING]: {
    label: (
      <Trans id="onboardingwelcome-workflows-outcome-categorized-label">
        Ensure timely response to customers
      </Trans>
    ),
    templates: ['sla-unreplied-customer-conversation'],
  },
  [OnboardingWorkflowsOutcomesV2.HANDLED]: {
    label: (
      <Trans id="onboardingwelcome-workflows-outcome-handled-label">Understand conversation trends</Trans>
    ),
    templates: ['tag-general-communications'],
  },
  [OnboardingWorkflowsOutcomesV2.CATEGORIZED]: {
    label: (
      <Trans id="onboardingwelcome-workflows-outcome-categorized-label">
        Give each conversation a clear owner
      </Trans>
    ),
    templates: [
      'tag-customer-communications',
      'assign-customer-conversation-to-group',
      'sla-unreplied-customer-conversation',
      'archive-invites',
    ],
  },
};
